import ISdkHooksProvider from './sdk-hooks-provider.interface';
import {MINI_CIP_BASE_ROUTE, MINI_CIS_BASE_ROUTE} from '../../services/mini-orbit/mini-orbit-consts';
import {Uri} from '../../services/location/uri/uri';
import {IServiceFactoryExtended} from '../../services/service-factory-extended.interface';
import {IOrbitComponentToSdkAdapterService} from '../../../common/interfaces/orbit-component-to-sdk-adapter/orbit-component-to-sdk-adapter.service.interface';
import {ICashierService} from "../../../common/interfaces/cashier.service.interface";

export class SdkHooksProvider implements ISdkHooksProvider {
    services: IServiceFactoryExtended;

    redirectProxy(url: string): void {
        if (!url) {
            return;
        }

        if (this.services) {
            //SDK is using this function to do redirects,
            //but we must do redirect only if the URL is an absolut URL.
            //If is a relative one like /gaming_history/ then we just need to do local routing
            if (this.services.window.isAbsolutUrl(url)) {
                this.services.location.redirect(url);
            } else {
                this.services.location.push(url);
            }
        } else {
            window.location.href = url;
        }
    };

    openInNewWindowHook(): (url: string) => void | null {
        if (this.services?.miniOrbit.isEnabled) {
            return this.services.miniOrbit.openUrl;
        } else {
            return null;
        }
    };

    isMiniCip(): boolean {
        return this._isMiniOrbit(MINI_CIP_BASE_ROUTE);
    }

    isMiniCis(): boolean {
        return this._isMiniOrbit(MINI_CIS_BASE_ROUTE);
    }

    private _isMiniOrbit(basePath: string): boolean {
        if (!this.services) {
            return false;
        }

        const uri = new Uri(new URL(window.location.href));
        return uri.pathName.getBase().toString().toLowerCase() === basePath;
    }

    getGameTypesMappingForSdk(): Record<number, any> {
        if (!this.services) {
            return null;
        }

        const mapperData: Record<number, any> = {};
        this.services?.configuration?.usedGameTypesBySite?.forEach(gameType => {
            mapperData[gameType] = {};
        });

        return mapperData;
    };

    getHeaderRegulationDataElement(): HTMLElement {
        return this.services?.header?.getHeaderRegulationDataElement();
    }

    resolveGameImagePath(imageFilePath: string): string {
        return this.services?.configuration?.resolveGameImagePath(imageFilePath);
    }

    getOrbitComponentToSdkAdapter(): IOrbitComponentToSdkAdapterService {
        return (this.services.orbitComponentInsideSdkProvider as any) as IOrbitComponentToSdkAdapterService;
    }

    getCashierService(): ICashierService {
        return this.services.cashier;
    }
}
